import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SearchableMenuErrorState(props) {
    const { children } = props;
    return (<Box alignItems="center" justifyContent="center" flexDirection="column" gap="md" py="2xl">
      <Falcon icon="exclamation" $size={16} $color="swatches.gray.700"/>
      <Typography $color="semantic.text.200">
        <Trans comment="Searchable menu error state">An error occurred</Trans>
      </Typography>
      {children}
    </Box>);
}
